import { render, staticRenderFns } from "./ModalDescarregadosOntemInfo.vue?vue&type=template&id=0e7282c9"
import script from "./ModalDescarregadosOntemInfo.vue?vue&type=script&lang=js"
export * from "./ModalDescarregadosOntemInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports